<!-- <div class="steps">
    <div class="seperator {{quantcastStep === 1 ? 'active' : 'inactive'}}" data-cy="quantcast-connect-step1-div"></div>
    <div class="seperator  {{quantcastStep === 2 ? 'active' : 'inactive'}} next"  data-cy="quantcast-connect-step2-div"></div>
</div> -->

<form [formGroup]="connectionForm">
    <ng-container *ngIf="quantcastStep === 1">
        <div class="title" mat-dialog-title>Add API Id & Secret</div>
        <div class="dialog-body">
            <div class="body-content">
                <div class="form-text">You will need to contact your Quantcast Account Manager to obtain the API Key and Secret. Please refer to <a
                        href="https://developers.quantcast.com/docs/get-started/authentication"
                        target="_blank" data-cy="quantcast-report-api-guide-link">this link</a>.</div>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>API Id</mat-label>
                    <input matInput placeholder="Enter Quantcast API Key" formControlName="apiKey"
                        data-cy="quantcast-email-input">
                    <mat-error *ngIf="connectionForm.get('apiKey').hasError('required')">API Key is required</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>API Secret</mat-label>
                    <input type="password" matInput placeholder="Enter Quantcast API Secret" formControlName="apiSecret"
                        data-cy="quantcast-password-input">
                    <mat-error *ngIf="connectionForm.get('apiSecret').hasError('required')">API Secret is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="dialog-footer">
            <div>
                <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()"
                    data-cy="quantcast-dialog-connect-data-btn">Connect Data
                    Source</button>
            </div>
        </div>
    </ng-container>
</form>